import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Joyride, STATUS } from 'react-joyride';
import axios from 'axios';
import trainingModules from '../../data/trainingModules';

// Herhangi bir sayfaya eklenen tek satırlık, yeniden kullanılabilir tur bileşeni.
// Training.js sayfasından "Öğren"e basılınca navigate(route, { state: { startTour: key } })
// ile buraya gelinir; bu bileşen kendi modülüne ait adımları bulup Joyride'ı başlatır.
const ModuleTour = ({ moduleKey }) => {
  const location = useLocation();
  const [run, setRun] = useState(false);
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    if (location.state?.startTour === moduleKey) {
      startedRef.current = true;
      // Sayfa ilk render'ında hedef elemanlar henuz DOM'da olmayabilir, bir tık bekle.
      const t = setTimeout(() => setRun(true), 300);
      return () => clearTimeout(t);
    }
  }, [location.state, moduleKey]);

  const handleCallback = (data) => {
    const { status } = data;
    if (status === STATUS.FINISHED) {
      setRun(false);
      axios.post(`/api/training/progress/${moduleKey}`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      }).catch(() => {});
    } else if (status === STATUS.SKIPPED) {
      setRun(false);
    }
  };

  const module = trainingModules.find(m => m.key === moduleKey);
  if (!module || !module.steps?.length) return null;

  // Varsayılan "beacon" (tıklanması gereken belirsiz nokta) adımını atlayıp doğrudan
  // açıklama kutucuğunu gösteriyoruz - kullanıcı ne yapacağını anlamakta zorlanmasın.
  // İlk adım olarak, herhangi bir elemanı işaret etmeyen (target:'body'), ekranın
  // ortasında açılan net bir "Eğitime Başlıyoruz" karşılama kartı ekliyoruz.
  const introStep = {
    target: 'body',
    placement: 'center',
    disableBeacon: true,
    title: `🎓 ${module.label} Eğitimine Başlıyoruz`,
    content: `Şimdi sizi ${module.label} ekranında adım adım gezdireceğiz. Devam etmek için "İleri"ye basın, istediğiniz an "Turu Atla" ile çıkabilirsiniz.`
  };
  // placement:'bottom' ZORUNLU - ekran görüntüleriyle doğrulandı: 'auto' bırakılınca
  // Joyride kutuyu sayfanın üst kısmındaki hedeflerin (başlık, filtre vb.) ÜSTÜNE
  // yerleştiriyor, kutunun üst kısmı da tarayıcının kendi adres çubuğunun arkasında
  // kalıp kesiliyor (bu, sayfa CSS'inin hiçbir zaman üzerine çıkamayacağı bir alan).
  // Hedefin ALTI sayfanın geri kalanı olduğu için orada her zaman yeterli yer var.
  const steps = [introStep, ...module.steps.map(s => ({ disableBeacon: true, placement: 'bottom', ...s }))];

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showSkipButton
      showProgress
      scrollToFirstStep
      disableScrolling={false}
      disableScrollParentFix
      scrollOffset={120}
      callback={handleCallback}
      locale={{ back: 'Geri', close: 'Kapat', last: 'Bitir', next: 'İleri', skip: 'Turu Atla' }}
      styles={{
        options: {
          arrowColor: '#0d1b2e',
          backgroundColor: '#0d1b2e',
          overlayColor: 'rgba(6,20,40,0.82)',
          primaryColor: '#00f2fe',
          textColor: '#f3f4f6',
          spotlightShadow: '0 0 0 3px #00f2fe, 0 0 20px 4px rgba(0,242,254,0.5)',
          beaconSize: 44,
          zIndex: 999999
        },
        tooltip: { borderRadius: 16, fontFamily: 'inherit', border: '1px solid rgba(0,242,254,0.35)' },
        tooltipTitle: { color: '#00f2fe', fontWeight: 700 },
        buttonNext: { borderRadius: 10, fontWeight: 600, background: '#00f2fe', color: '#04121a' },
        buttonBack: { color: '#9ca3af' },
        buttonSkip: { color: '#9ca3af' }
      }}
    />
  );
};

export default ModuleTour;
